import React from "react"
import BigCalendar from "react-big-calendar"
import moment from "moment"
import autobind from "class-autobind"
import { MonthEvent, IScheduleDetailMonthEvent } from "."
import { IScheduleDocument, EDayOfWeek } from '../../../../models';
import * as timeHelper from "../../../../helpers/timeHelper"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import TimeActionBar from "../../../common/TimeActionBar/TimeActionBar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "./styles.css"
interface IProps {
  schedule: IScheduleDocument
  handleGoToDayView(date: Date | string): void
}
interface IState {
  referenceDate: Date | string
  showCalendar: boolean
}

export default class ScheduleTimeinfoDetailMonthView extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      referenceDate: moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).toDate(),
      showCalendar: true,
    }
    autobind(this)
  }

  componentDidMount() {
    if (document.getElementById("TimeActionBar")) {
      document.getElementById("TimeActionBarDate").style.width = "140px"
      document.getElementById("TimeActionBarDateArrow").style.width = "175px"
      document.getElementById("TimeActionBar").style.width = "670px"
    }
  }

  render() {
    const events: IScheduleDetailMonthEvent[] = []
    this.props.schedule.Schedules.forEach(item => {
      const day = moment(scheduleHelper.getTimeFromSimpleTime(scheduleHelper.getStartEndSimpleTimeOfPatternTemplate(item).StartSimpleTime)).toDate()
      events.push({
        start: day,
        end: day,
        patternTemplate: item,
        //handleGoToDayView: () => this.props.handleGoToDayView(moment(day).diff(utils.keepConvertUTCToLocal(this.props.schedule.StartDate), "day"))
        handleGoToDayView: () => this.props.handleGoToDayView(day)
      })
    })
    return (
      <div style={{ position: "relative", marginTop: 30 }}>
        <div style={{ position: "absolute", top: -90 }}>
          <TimeActionBar
            referenceDate={this.state.referenceDate}
            handleChangeTimeRange={(StartDate, EndDate) => this.setState({ referenceDate: StartDate, showCalendar: false }, () => this.setState({ showCalendar: true }))}
            startDayOfWeek={EDayOfWeek.Monday}
            timeBarViewType="month"
          />
        </div>
        {this.state.showCalendar &&
          <BigCalendar
            popup
            views={{ month: true, week: false }}
            defaultView={BigCalendar.Views.MONTH}
            step={60}
            className={"ScheduleDetailMonth-container"}
            localizer={BigCalendar.momentLocalizer(moment)}
            events={events}
            defaultDate={moment(this.state.referenceDate).toDate()}
            showMultiDayTimes={true}
            eventPropGetter={() => ({ className: "ScheduleDetailMonth-Event-Node" })}
            toolbar={false}
            components={{
              month: { event: MonthEvent }
            }}
          />
        }
      </div>
    )
  }
}
